import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  subtitle: {
    marginBottom: theme.spacing(2),
  },
  text: {
    marginBottom: theme.spacing(2),
  },
  downloadContainer: {
    backgroundColor: "rgb(226, 231, 239,0.3)",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
  },
  uploadContainer: {
    backgroundColor: "rgb(226, 231, 239,0.3)",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    cursor: "pointer",
  },
  editIcon: {
    position: "absolute",
    top: -10,
    right: -10,
  },
  fileName: {
    wordBreak: "break-all",
  },
  buttonsContainer: {
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-start",
    },
  },
  importButton: {
    [theme.breakpoints.down("xs")]: {
      marginLeft: theme.spacing(5),
    },
  },
}))

export default styles
